import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'formazione',
  titolo: 'Preparare e condurre una formazione',
  gruppo: 'Report e gestione',
  permesso: 'formazione.gestisci',
  aCheServe: 'La sede di formazione ha schede inventate e utenti di prova per mostrare il gestionale ai '
    + 'colleghi. Dalla pagina «Formazione» la rimetti come all’inizio prima e dopo ogni incontro.',
  parti: [
    {
      titolo: 'Prima dell’incontro',
      passi: [
        'Apri «Formazione» nel menu e guarda gli utenti di prova e quante schede ci sono nella sede.',
        'Premi «Ripristina la formazione», scegli fino a quando valgono gli incarichi e conferma.',
        'Le password nuove degli utenti di prova compaiono una volta sola: stampale o copiale e consegnale a '
          + 'mano. Poi premi «Ho consegnato le password: nascondile».',
      ],
      nota: 'Mai le password per email o in chat. Gli utenti di prova non devono attivare il secondo fattore.',
    },
    {
      titolo: 'Durante e dopo',
      passi: [
        'Segui la traccia del riquadro «Come si conduce una formazione».',
        'Chi ha già la sua utenza può provare da sé con «Palestra», senza utenti di prova.',
        'Alla fine ripristina di nuovo: le schede create durante l’incontro spariscono, il registro eventi resta.',
      ],
    },
  ],
  avvertenze: [
    {
      quando: 'La sede di formazione non compare negli elenchi, nei report o nelle esportazioni.',
      cosaFare: 'È voluto: i dati inventati restano fuori dai dati veri. Si vedono con gli utenti di prova o in '
        + 'Palestra.',
    },
  ],
  vediAnche: ['palestra', 'utenti'],
  parole: ['formazione', 'corso', 'ripristina', 'utenti di prova', 'password di prova'],
}

export default capitolo
